import { Injectable } from '@angular/core';
import { RegisterUserModel } from '../../models/registeruser.model';
import { GlobalsService } from '../globals/globals.service';
import { environment } from 'src/environments/environment';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { DomainService } from '../domain/domain.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private user: RegisterUserModel;

  constructor(private _globals: GlobalsService, private _storage: StoragePermissionService, private _domain: DomainService) {}

  getUserData(regForm: any, dialcode: string, countryID: number, stateID: number): RegisterUserModel {
    const userIP = this._storage.getUserIP();
    let affOBJ: any = this._globals.getAffiliateCookies();
    let paramOBJ: any = this._globals.getDataFromParams();
    paramOBJ = this._globals.checkDirectOrganic(paramOBJ, affOBJ);
    var data: RegisterUserModel = Object.assign(affOBJ, regForm);
    data = Object.assign(paramOBJ, data);
    this.user = {
      ...data,
      password_confirmation: data.password,
      country: countryID,
      usr_state: stateID,
      phone: dialcode + data.phone,
      language: this._globals.getFormattedLang('es'),
      site_id: this._domain.getCurrentDomain().parentSiteId,
      user_ip: userIP
    };

    let { multisite, type } = environment;

    if (multisite.view === '.freeplay') {
      this.user = {
        ...this.user,
        source: environment.source
      };
    } else {
      this.user = {
        ...this.user,
        usr_source: environment.source
      };
    }

    if (multisite.view == '.casino' && type != 'casino-deposit') {
      this.user = {
        ...this.user,
        pcbr: this._storage.getCasinoGame().promo
      };
    }

    if (multisite.view == '.simple-casino' && type != 'casino-deposit') {
      this.user = {
        ...this.user,
        pcbr: this._storage.getCasinoGame().promo
      };
    }

    return this.user;
  }
}
